<ng-container *ngIf="isAuthenticated && isSessionReady && currentStateName !== LOGIN && currentStateName !== ONBOARDING; else emptyContainer">
    <div class="c-app__left-panel">
        <div class="c-app__left-panel-header">
            <div payAppFlavourClass class="c-app__brand-logo"></div>
        </div>
        <div class="c-app__left-panel-content">
            <pay-navigation-menu ></pay-navigation-menu>
        </div>
    </div>
    <div class="c-app__right-panel">
        <div class="c-app__right-panel-header">
            <pay-context-bar [isDynamic]="true">
            </pay-context-bar>
            <pay-profile-menu class="ml-auto"></pay-profile-menu>
        </div>
        <div class="c-app__right-panel-content">
            <!-- app content goes here -->
            <ui-view></ui-view>
        </div>
    </div>
</ng-container>

<ng-template #emptyContainer>
    <ui-view *ngIf="(isSessionReady && isAuthenticated) || !isAuthenticated; else appLoader"></ui-view>
</ng-template>

<ng-template #appLoader>
    <div class="c-app__loader-wrapper">
        <div class="c-app__loader-icon" payAppFlavourClass></div>
    </div>
</ng-template>

<ui-view name="dialog"></ui-view>
<ui-view name="overlay"></ui-view>
<pay-mobile-blocker></pay-mobile-blocker>